import {createSlice, PayloadAction} from '@reduxjs/toolkit'

interface UiState {
    isMobile: boolean;
    isFundsCredited: boolean;
    isCaptchaReady: boolean;
    isAnjReady: boolean;
    isH2H: boolean;
}

export const uiInitialState = {
    isFundsCredited: false,
    isMobile: false,
    isCaptchaReady: false,
    isAnjReady: false,
    isH2H: false,
} satisfies UiState as UiState

const uiSlice = createSlice({
    name: 'ui',
    initialState: uiInitialState,
    reducers: {
        setIsFundsCredited(state, val: PayloadAction<boolean>) {
            state.isFundsCredited = val.payload;
        },
        setIsCaptchaReady(state, action: PayloadAction<boolean>) {
            state.isCaptchaReady = action.payload;
        },
        setIsAnjReady(state, action: PayloadAction<boolean>) {
            state.isAnjReady = action.payload;
        },
        setIsH2H(state, action: PayloadAction<boolean>) {
            state.isH2H = action.payload;
        }
    },
})

export const {setIsFundsCredited, setIsCaptchaReady, setIsAnjReady, setIsH2H} = uiSlice.actions
export const uiReducer = uiSlice.reducer;
